module.exports = __webpack_public_path__ + "img/组 7@2x.d3d76790.png";